module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/alarm-type/alarm-type.component.css
// module id = ./src/app/alarm-type/alarm-type.component.css
// module chunks = main